import { ReactNode } from "react";

export const timelineMode = {
  simple: "simple",
  sentiments: "sentiments",
  karaoke: "karaoke",
} as const;

export type TimelineMode = (typeof timelineMode)[keyof typeof timelineMode];

export type TimelineModePickerProps = {
  mode: TimelineMode;
  onClickSimple: () => void;
  onClickKaraoke: () => void;
  onClickSentiments: () => void;
};

export type DropdownMenuItemProps = {
  children: ReactNode;
  active: boolean;
  onClick: () => void;
  "data-test": string;
};
